"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.t = exports.i18n = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/bind"));
var _i18next = _interopRequireDefault(require("i18next"));
var _i18nextChainedBackend = _interopRequireDefault(require("i18next-chained-backend"));
var _i18nextSprintfPostprocessor = _interopRequireDefault(require("i18next-sprintf-postprocessor"));
var _getI18nInitOptions = require("./utils/get-i18n-init-options");
var _preSprintf = require("./pre-sprintf");
var _context, _context2;
/**
 * Internationalization tool for translations. An opinionated, batteries-included wrapper around [i18next](https://www.i18next.com) designed to lazy load translations. If you don't need lazy loading, you're probably better off using [i18next](https://www.i18next.com) directly.
 *
 * ## Getting Started
 *
 * The basic idea is:
 * 1. Create translation files ("resources")
 * 2. Load translation files into `i18n`
 * 3. Use `t` to lookup translations
 *
 * Resources are JSON files that map unique keys to translated phrases. `i18n` assumes English as the base language that developers will use. As such, although non-English resources are simple key-value pairs, English supports a different structure that allows for metadata like notes, context, etc. to be provided. Each key in an English resource should map to an object, which must have a `translation` key.
 *
 * @example
 * ```
 * // your/translations/path/en/common.json
 * {
 * 	"hello": {
 * 		"translation": "Hello {{name}}"
 * 	},
 * 	"messages": {
 * 		"translation": {
 * 			"one": "You have {{count}} message",
 * 			"other": "You have {{count}} messages",
 * 		},
 * 		"notes": "Helpful info for translators here"
 * 	}
 * }
 *
 * // your/translations/path/de/common.json
 * {
 * 	"hello": "Hallo {{name}}",
 * 	"messages_one": "Sie haben {{count}} Nachricht",
 * 	"messages_other": "Sie haben {{count}} Nachrichten"
 * }
 * ```
 *
 * Once you have resources in place, you can initialize `i18n` and start translating.
 *
 * @see {@link i18n.init} to get started.
 */
// spreading seems to break functionality, so we assign and then override
const i18n = exports.i18n = _i18next.default.createInstance();

// allow consumers to create a separate instance if needed.
// although types says this should exist on an instance, it doesn't at runtime
i18n.createInstance = (0, _bind.default)(_context = _i18next.default.createInstance).call(_context, _i18next.default);

// make importing `t` easier as it will be ubiquitous
const t = exports.t = (0, _bind.default)(_context2 = i18n.t).call(_context2, i18n);
i18n
// Use sprintf for backwards compatibility with existing translations.
// Can be removed when all translations have been updated.
.use(_preSprintf.preSprintf).use(_i18nextSprintfPostprocessor.default).use(_i18nextChainedBackend.default);

// wrap init to apply default options
const originalInit = i18n.init;
const init = (...args) => {
  const [optionsOrCallback, callback] = args;
  if (typeof optionsOrCallback === 'function') {
    return originalInit(optionsOrCallback);
  }
  return originalInit((0, _getI18nInitOptions.getI18nInitOptions)(optionsOrCallback), callback);
};
i18n.init = init;